module.exports = __webpack_public_path__ + "img/perangkatsvg.13ca712b.svg";